import React from 'react';

import { StyleSheet, Text, View } from '@react-pdf/renderer';

interface IHeaderProps {
  date: string[];
  paddingLeft: string;
}

export const ProgressHeader: React.FC<IHeaderProps> = ({ date, paddingLeft }) => {
  const datesLength = date.length;
  const newDates: string[] = [];

  for (const data of date) {
    if (datesLength > 10) {
      newDates.push(data.slice(0, 3) + data.slice(5));
    } else {
      newDates.push(data);
    }
  }

  return (
    <View fixed style={[styles.headerWrap, { paddingLeft }]}>
      {newDates.map((date) => (
        <View style={styles.ceil} key={date}>
          <Text style={[styles.data, {fontSize: datesLength > 14 ? 7 : 9}]}>{date}</Text>
        </View>
      ))}
    </View>
  );
};

const styles = StyleSheet.create({
  headerWrap: {
    width: '100%',
    height: '19px',
    display: 'flex',
    flexDirection: 'row',
    color: '#212121',
    borderTop: '0.3px dotted #77787C',
    borderBottom: '0.3px dotted #77787C',
  },
  ceil: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
  },
  data: {
    fontFamily: 'Noto',
    fontWeight: 600,
    color: '#000000',
  },
});
